import { render, staticRenderFns } from "./find-Act.vue?vue&type=template&id=6fb6dbd0&scoped=true&"
import script from "./find-Act.vue?vue&type=script&lang=js&"
export * from "./find-Act.vue?vue&type=script&lang=js&"
import style0 from "./find-Act.vue?vue&type=style&index=0&id=6fb6dbd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb6dbd0",
  null
  
)

export default component.exports